import React, { useState, useEffect } from 'react';
import {
    Typography,
    Paper,
    Box,
    Stack,
    Button,
    Grid,
    Skeleton,
    useMediaQuery,
    Tooltip,
    useTheme,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    RadioGroup,
    FormControlLabel,
    Radio,
    Snackbar,
    Alert,
    Card,
    CardContent,
} from '@mui/material';
import { useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import parse from "html-react-parser";
import RecommendRoundedIcon from '@mui/icons-material/RecommendRounded';
import {
    BusinessCenterRounded,
    ChecklistRtlRounded,
    FlightRounded,
    SchoolRounded,
    WorkHistoryRounded,
} from "@mui/icons-material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const SourcesJobdetailsview = ({ loading, jobs }) => {
    const {
        selectedCandidate,
        solrJobs,
        candidate,
        selectedJob,
        selectedJobLoading,
        selectedSubmission,
        sendJobToCandidate,
        getSubmissionsByJobAction,
    } = useSelector(appSelector);
    //console.log("selectedJob", selectedJob)
    const [interested, setInterested] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [resumeOption, setResumeOption] = useState('existing');
    const [toastOpen, setToastOpen] = useState(false);

    const theme = useTheme();
    const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops

    const handleButtonClick = () => {
        if (!interested) {
            setDialogOpen(true);
        } else {
            setInterested(false);
        }
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleApply = () => {
        setDialogOpen(false);
        setInterested(true);
        setToastOpen(true);
    };
    const scrollBodySx = {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "hidden",
        px: 1,
        pb: 1,
    };

    const showJobDetailsSkeleton =
        selectedJobLoading || (loading && jobs.length === 0);

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                {showJobDetailsSkeleton ? (
                    <Box sx={{ p: 1 }}>
                        <Skeleton variant="text" width="50%" height={36} />
                        <Skeleton variant="text" width="70%" height={24} sx={{ mt: 1 }} />
                        <Skeleton variant="text" width="50%" sx={{ mt: 2 }} />
                        <Skeleton variant="text" width="60%" />
                        <Skeleton variant="text" width="70%" />
                        <Skeleton variant="text" width="90%" />
                        <Skeleton variant="rectangular" height={460} sx={{ mt: 1 }} />
                    </Box>
                ) : jobs.length === 0 ? (
                    <Card sx={{ m: 1 }}>
                        <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 6 }}>
                            <Typography variant="body2" component="h2" gutterBottom>
                                No Job Selected
                            </Typography>
                        </CardContent>
                    </Card>)
                    :
                    (
                        <>
                            <Box
                                sx={{
                                    flexShrink: 0,
                                    px: 1,
                                    pt: 1,
                                    pb: 1,
                                    bgcolor: "#fff",
                                    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    title={selectedJob?.jobtitle}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontSize: "18px",
                                    }}
                                >
                                    {selectedJob?.jobtitle?.slice(0, 55)}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: "rgba(0, 0, 0, 0.6)",
                                        fontSize: "13px",
                                        marginTop: "8px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {selectedJob?.company_name} {selectedJob?.location ? selectedJob.location : "Remote"}
                                </Typography>
                            </Box>

                            <Box sx={scrollBodySx}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", paddingTop: "12px" }}>
                                <Stack direction="column" gap={1}>
                                    {selectedJob?.jobtype_name &&
                                        <Typography
                                            paragraph
                                            sx={{
                                                margin: 0,
                                                display: "flex",
                                                alignItems: "end",
                                                gap: "2px",
                                                fontSize: "12px", // Set font size in pixels
                                                minWidth: "80px",
                                                maxWidth: isDesktopLarge ? "500px" : "200px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            <BusinessCenterRounded
                                                sx={{
                                                    height: isDesktopLarge ? "20px" : "18px",
                                                    width: isDesktopLarge ? "20px" : "18px",
                                                    color: "#757575",
                                                    marginRight: "5px",
                                                }}
                                            />
                                            {selectedJob?.jobtype_name !== undefined &&
                                                selectedJob?.jobtype_name !== null
                                                ? selectedJob?.jobtype_name
                                                : "Full Time"}
                                        </Typography>
                                    }
                                    {
                                        selectedJob?.qualifications &&
                                        <Typography
                                            paragraph
                                            sx={{
                                                margin: 0,
                                                fontSize: "12px", // Set font size in pixels
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "2px",
                                            }}
                                        >
                                            <SchoolRounded
                                                style={{
                                                    height: isDesktopLarge ? "20px" : "18px",
                                                    width: isDesktopLarge ? "20px" : "18px",
                                                    color: "#757575",
                                                    marginRight: "5px",
                                                }}
                                            />
                                            {selectedJob?.qualifications !== undefined &&
                                                selectedJob?.qualifications !== null &&
                                                selectedJob?.qualifications !== ""
                                                ? selectedJob?.qualifications
                                                : "N/A"}
                                        </Typography>
                                    }
                                    {selectedJob?.experience != null &&
                                        String(selectedJob.experience).trim() !== "" && (
                                            <Typography
                                                paragraph
                                                sx={{
                                                    margin: 0,
                                                    fontSize: "12px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "2px",
                                                }}
                                            >
                                                <WorkHistoryRounded
                                                    style={{
                                                        height: isDesktopLarge ? "20px" : "18px",
                                                        width: isDesktopLarge ? "20px" : "18px",
                                                        color: "#757575",
                                                        marginRight: "5px",
                                                    }}
                                                />
                                                {String(selectedJob.experience).trim() === "0"
                                                    ? "0 - 3 Years"
                                                    : selectedJob.experience}
                                            </Typography>
                                        )}
                                    {selectedJob?.salaryrangetype && selectedJob?.salaryrange && (
                                        <Typography
                                            paragraph
                                            sx={{
                                                margin: 0,
                                                fontSize: "12px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "2px",
                                            }}>
                                            <AttachMoneyIcon style={{
                                                height: isDesktopLarge ? "20px" : "18px",
                                                width: isDesktopLarge ? "20px" : "18px",
                                                color: "#757575",
                                                marginRight: "5px",
                                            }} />
                                            {`${selectedJob.salaryrange} ${selectedJob.salaryrangetype}`}
                                        </Typography>
                                    )}
                                    <Tooltip
                                        title={selectedJob?.required_skills}
                                        arrow
                                        placement="top"
                                        enterTouchDelay={500}
                                    >
                                        <Typography
                                            paragraph
                                            sx={{
                                                margin: 0,
                                                fontSize: "12px", // Set font size in pixels
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "2px",
                                                cursor: "pointer",
                                                marginBottom: "10px",
                                                maxWidth: isDesktopLarge ? "500px" : "200px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                "&:hover": {
                                                    textDecoration: "underline",
                                                },
                                            }}
                                        // onClick={scrollToSkillMatch}
                                        >
                                            <ChecklistRtlRounded
                                                style={{
                                                    height: isDesktopLarge ? "20px" : "18px",
                                                    width: isDesktopLarge ? "20px" : "18px",
                                                    color: "#757575",
                                                    marginRight: "5px",
                                                }}

                                            />
                                            {selectedJob?.required_skills ? selectedJob?.required_skills?.slice(0, 80) + "..." : "N/A"}
                                        </Typography>
                                    </Tooltip>
                                </Stack>
                            </Box>
                            <Stack>
                                {/* <Typography variant="subtitle1" sx={{ marginTop: 2 }}>Description:</Typography> */}
                                <Grid item xs={12}>
                                    <Paper sx={{ boxShadow: "none", padding: "10px" }}>
                                        <Typography paragraph sx={{ fontWeight: 500 }}>
                                            About the job
                                        </Typography>
                                        <div style={{ fontSize: '12px' }}>
                                            {selectedJob?.job_description !== null &&
                                                selectedJob?.job_description !== undefined &&
                                                selectedJob?.job_description ? (
                                                !selectedJob?.job_description.includes("ahref") &&
                                                    !selectedJob?.job_description.includes("divclass") &&
                                                    !selectedJob?.job_description.includes("aclass") &&
                                                    !selectedJob?.job_description.includes("pclass") &&
                                                    !selectedJob?.job_description.includes("liclass") ? (
                                                    parse(selectedJob?.job_description.replace(/<([^@\s>]+@[^@\s>]+)>/g, '&lt;$1&gt;'))
                                                ) : (
                                                    selectedJob?.job_description.replace(/<[^>]+>/g, "")
                                                )
                                            ) : ""}
                                        </div>
                                    </Paper>
                                </Grid>
                            </Stack>
                            </Box>
                        </>
                    )}

            <Dialog open={dialogOpen} onClose={handleDialogClose}>
                <DialogTitle>Apply to this Job</DialogTitle>
                <DialogContent>
                    <RadioGroup
                        aria-label="resume"
                        name="resume"
                        value={resumeOption}
                        onChange={(e) => setResumeOption(e.target.value)}
                    >
                        <FormControlLabel value="existing" control={<Radio />} label="Apply with existing resume" />
                        <FormControlLabel value="upload" control={<Radio />} label="Upload new resume" />
                    </RadioGroup>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Cancel</Button>
                    <Button onClick={handleApply} variant="contained" color="primary">
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={toastOpen} autoHideDuration={6000} onClose={() => setToastOpen(false)}>
                <Alert onClose={() => setToastOpen(false)} severity="success">
                    Successfully applied!
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default React.memo(SourcesJobdetailsview);
